<script lang="ts">
import { RangeSliderComponent } from "./range-slider.ts";
export default RangeSliderComponent;
</script>

<template>
    <div class="range-slider app-range-slider">
        <app-block-ui :blocked="blocked">
            <div :style="{ height: '60px' }">
                <canvas v-app-fit-canvas-to-container v-app-chart="chartOptions"></canvas>
            </div>
            <div
                class="steps-slider"
                v-app-nouislider="sliderOptions"
                :style="{ marginTop: '3px' }"
                @change="onSliderChange"
                v-if="options.length > 1"
            ></div>
            <div class="range-slider__inputs">
                <div class="range-slider__input-block">
                    <span class="range-slider__placeholder p-text-capitalize">
                        <i18n-t keypath="common.min" />
                        :
                    </span>
                    <div class="range-slider__input-wrapper">
                        <input
                            class="range-slider__input js-size-receiver"
                            type="number"
                            id="input-1"
                            v-bind="minAttrs"
                            :min="minOptionValue"
                            :max="to"
                            :value="from"
                            @change="onChangeMinValue"
                        />
                        <span class="js-size-dealer">{{ from }}</span>
                    </div>
                    <span class="range-slider__units">{{ unit }}</span>
                </div>
                <div class="range-slider__input-block">
                    <span class="range-slider__placeholder p-text-capitalize">
                        <i18n-t keypath="common.max" />
                        :
                    </span>
                    <div class="range-slider__input-wrapper">
                        <input
                            class="range-slider__input js-size-receiver"
                            type="number"
                            id="input-2"
                            v-bind="maxAttrs"
                            :min="from"
                            :max="maxOptionValue"
                            :value="to"
                            @change="onChangeMaxValue"
                        />
                        <span class="js-size-dealer">{{ to }}</span>
                    </div>
                    <span class="range-slider__units">{{ unit }}</span>
                </div>
            </div>
        </app-block-ui>
    </div>
</template>

<style lang="scss" scoped>
.range-slider__input::-webkit-outer-spin-button,
.range-slider__input::-webkit-inner-spin-button {
    -webkit-appearance: none;
}
.range-slider__input {
    -moz-appearance: textfield;
    &-wrapper {
        flex-grow: 1;
    }
}
.range-slider__inputs .js-size-dealer {
    padding: 0.3em 0.45em 0.3em 0.3em;
}
</style>
